export const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'] as const;
export type QuarterKey = (typeof QUARTERS)[number];

export type YearSeasonLock = {
  evalYear: number;
  /** true = 해당 분기 입력·확정 변경 잠금 */
  quarters: Record<QuarterKey, boolean>;
  peerEvalLocked: boolean;
  taskRegisterLocked: boolean;
  calibrationLocked: boolean;
  updatedAt?: number;
  updatedBy?: string;
  note?: string;
};

export function emptyYearSeasonLock(evalYear: number): YearSeasonLock {
  return {
    evalYear,
    quarters: { Q1: false, Q2: false, Q3: false, Q4: false },
    peerEvalLocked: false,
    taskRegisterLocked: false,
    calibrationLocked: false,
  };
}

export function seasonLockDocId(evalYear: number) {
  return `season_lock_${evalYear}`;
}

export function isQuarterSeasonLocked(lock: YearSeasonLock | null | undefined, quarter: string): boolean {
  if (!lock) return false;
  if (quarter !== 'Q1' && quarter !== 'Q2' && quarter !== 'Q3' && quarter !== 'Q4') return false;
  return Boolean(lock.quarters[quarter]);
}

export function normalizeSeasonLock(evalYear: number, raw: Partial<YearSeasonLock> | null | undefined): YearSeasonLock {
  const base = emptyYearSeasonLock(evalYear);
  if (!raw) return base;
  return {
    ...base,
    ...raw,
    evalYear,
    quarters: {
      Q1: Boolean(raw.quarters?.Q1),
      Q2: Boolean(raw.quarters?.Q2),
      Q3: Boolean(raw.quarters?.Q3),
      Q4: Boolean(raw.quarters?.Q4),
    },
    peerEvalLocked: Boolean(raw.peerEvalLocked),
    taskRegisterLocked: Boolean(raw.taskRegisterLocked),
    calibrationLocked: Boolean(raw.calibrationLocked),
  };
}
